<template>
    <v-container>
        <v-card>
            <div v-if="showcargando == true" id="cargando" wire:loading
                class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
                <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
                <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
                <p class="w-1/3 text-center text-white">
                    Esto puede tardar unos segundos, no cierre esta página.
                </p>
            </div>
            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                    <v-card flat class="text-xs-center ma-3" width="100%">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Atención al reporte</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-badge-account-alert-outline</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <vs-list v-for="dato in datosAP" :key="dato.txtLabelTitulo">
                                        <vs-list-item :title="dato.txtLabelTitulo"
                                            :subtitle="dato.txtLabelDato"></vs-list-item>
                                    </vs-list>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <LibVehRLV v-if="this.info.LibVeh">
                </LibVehRLV>
                <Expediente></Expediente>
            </v-layout>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Reporte from '@/services/asistenciaRLV/AsistenciaRLV.service.js';
import LibVehRLV from '@/components/pages/detalleReporte/RLV/LibVehRLV.vue';
import Expediente from '@/components/pages/detalleReporte/Movimientos/Expediente.vue';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
    components: {
        LibVehRLV,
        Expediente
    },
    data: function () {
        return {
            showcargando: true,
            info: [],
            datosAP: [],
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    methods: {
        async ObtenerDatosAvePrev() {
            this.datosAP = await Reporte.DatosAsistencia(this, this.info.proceso, 1);
            for (let i in this.datosAP) {
                for (const [key, value] of Object.entries(this.datosAP[i])) {
                    if (typeof value == "object") {
                        this.datosAP[i][key] = ""
                    }
                }
            }
            this.showcargando = false;

        },
    },
    async mounted() {
        this.showcargando = true;
        let encabezado = await Reporte.EncabezadoReporte(this);
        encabezado.LibVeh = encabezado.LibVeh == 1 ? true : false;
        encabezado.ApodLeg = encabezado.ApodLeg == 1 ? true : false;
        var infoSesion = {
            proceso: parseInt(encabezado.proceso),
            libVeh: encabezado.LibVeh,
            procesolibVeh: 6,
            apodLeg: encabezado.ApodLeg
        };
        await MetodosGenerales.guardarEnSesionInfoReporte(infoSesion, "info");
        this.info = encabezado
        await this.ObtenerDatosAvePrev();
    }
}

</script>